import React, { createContext, useState, useContext, ReactNode } from 'react';

interface ToggleHeaderMenuProps {
  showMenu: { [key: string]: boolean };
  toggleMenu: (slug: string) => void;
  closeAllMenus: () => void;
  menus: string[];
}

const ToggleHeaderMenuContext = createContext<ToggleHeaderMenuProps>({} as ToggleHeaderMenuProps);

interface Props {
  children: ReactNode;
}

const DropdownProvider: React.FC<Props> = ({ children }: Props) => {
  const [showMenu, setShowMenu] = useState<{ [key: string]: boolean }>({});

  const menus = ['help', 'user'];

  window.onclick = (e: any): void => {
    menus.forEach((menu) => {
      const dropdownParent = document.getElementById(`dropdown-container-${menu}`);
      const buttonSeeAll = document.getElementById(`button-see-all-videos`);

      if (!buttonSeeAll?.contains(e.target) && !dropdownParent?.contains(e.target) && showMenu[menu]) {
        closeAllMenus();
      }
    });
  };

  /*
    Para ativar o menu dropdown, passar como parâmetro desta
    função um dos slugs declarados na constante menus
  */

  const toggleMenu = (slug: string): void => {
    const menuState: { [key: string]: boolean } = {
      user: false,
      help: false,
    };

    menuState[slug] = !menuState[slug];

    setShowMenu(menuState);
  };

  const closeAllMenus = (): void => {
    setShowMenu({
      user: false,
      help: false,
    });
  };

  return (
    <ToggleHeaderMenuContext.Provider value={{ showMenu, toggleMenu, closeAllMenus, menus }}>
      {children}
    </ToggleHeaderMenuContext.Provider>
  );
};

const useDropdown = (): ToggleHeaderMenuProps => {
  const context = useContext(ToggleHeaderMenuContext);

  if (!context) {
    throw new Error('useDropdown deve ser usado dentro do seu Provider');
  }

  return context;
};

export { DropdownProvider, useDropdown };
